module.exports = __webpack_public_path__ + "img/Toyota-2019-C-HR-2.a1505183.png";